module.exports = __webpack_public_path__ + "static/img/unionpay.a2454bc7.png";